"use client";

import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bell } from "lucide-react";

type PendingInvitationsTriggerProps = {
  count: number;
  onClick: () => void;
};

export function PendingInvitationsTrigger({ count, onClick }: PendingInvitationsTriggerProps) {
  if (count === 0) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      variant="default"
      className="relative w-full justify-start gap-2 bg-primary hover:bg-primary/90 sm:w-auto"
    >
      <Bell className="h-4 w-4" />
      <span>Pending Invitations</span>
      <Badge
        variant="secondary"
        className="ml-auto bg-background/90 text-foreground hover:bg-background"
      >
        {count}
      </Badge>
    </Button>
  );
}

